import { FiBook, FiBookOpen, FiHelpCircle, FiMinus, FiShield } from "react-icons/fi";
import { s1 } from "../assets";
import styles from "../style";
import { Reveal } from "./reveal";
import FeatureAccord from "./FeatureCard_accordion";
import { features } from "../constants";

const Business = () =>  {
  return (
  <div className={`relative flex flex-col md:flex-row gap-10 justify-center items-start pt-20 px-10`}>                    
      <div className="flex flex-col gap-10 items-start">
        <Reveal className="flex flex-col gap-4 items-start">
            <Reveal>
                <h2 className="text-mm font-bold mt-20 text-fourth">
                What We Do
                </h2>
            </Reveal>
            <h2 className="pt-4 xs:text-md text-md font-semibold max-w-[300px]">
                A mission,
            </h2>
            <h2 className="xs:text-md text-md font-semibold max-w-[300px] text-secondary">
                Four variations
            </h2>
        </Reveal>          
      </div>
      <FeatureAccord features={features} className="absolute"/>
  </div>
)};

export default Business;